import Util from '../util';

const url = '/api/colorcalc/user_units';
const Api = {
  /**
   * @param {object} params
   */
  deleteAsync(
    { projectId: project_id, productId: product_id }
  ) {
    const queryString = Util.queryString({project_id, product_id});
    return fetch(`${Util.apiSegment}${url}${queryString}`, {
      method: 'DELETE'
    }).then(response => response.json());
  },
  /**
   * @param {object} params
   * @param {object} data
   */
  pathAsync(
    { projectId: project_id, productId: product_id, unitId },
    { number, dateDt, ticket, measurementL, measurementA, measurementB }
  ) {
    const segment = `/${unitId}`;
    const queryString = Util.queryString({project_id, product_id});
    return fetch(`${Util.apiSegment}${url}${segment}${queryString}`, {
      method: 'PATCH',
      body: JSON.stringify({ number, dateDt, ticket, measurementL, measurementA, measurementB }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json());
  },
  /**
   * PUT
   * @param {object} params
   * @param {object} data
   */
  putAsync(
    { projectId: project_id, productId: product_id },
    { measurementL, measurementA, measurementB, measurementD }
  ) {
    const queryString = Util.queryString({project_id, product_id});
    return fetch(`${Util.apiSegment}${url}${queryString}`, {
      method: 'PUT',
      body: JSON.stringify({ measurementL, measurementA, measurementB, measurementD }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json());
  },
  /**
   * @param {object} params
   * @param {object} data
   */
  postAsync(
    { projectId: project_id, productId: product_id },
    { number, dateDt, ticket, measurementL, measurementA, measurementB }
  ) {
    const queryString = Util.queryString({project_id, product_id});
    return fetch(`${Util.apiSegment}${url}${queryString}`, {
      method: 'POST',
      body: JSON.stringify({ number, dateDt, ticket, measurementL, measurementA, measurementB }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json());
  }
};

export default Api;